<template>
  <myhead @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <div>
    <div class="shopindex">
      <div class="flex center shopindex-bar size12">
        <div class="flex" @click="handleSel(4)">
          <p class="ml16">时间</p>
          <img
            :src="
              condition == 4 && sort == 1
                ? require('@/assets/img/icon58.png')
                : condition == 4 && sort == 2
                ? require('@/assets/img/icon57.png')
                : require('@/assets/img/icon59.png')
            "
            class="height14px"
          />
        </div>
      </div>
    </div>
    <div class="score-container">
      <div class="score-list">
        <div class="shopcontainer">
          <div class="shoplist">
            <van-list
              v-model:loading="loading"
              :finished="finished"
              @load="onLoad"
            >
              <div class="shoplist-li-box">
                <div
                  class="shoplist-li"
                  v-for="(item, index) in goosList"
                  :key="index"
                >
                  <img
                    :src="item.original_img"
                    :onerror="imgError"
                    class="shoplist-li__shopimg"
                    @click="
                      $router.push({
                        path: '/shop/detail',
                        query: { goods_id: item.goods_id },
                      })
                    "
                  />
                  <p class="shoplist-li__tle">
                    {{ item.goods_name }}
                  </p>
                  <div class="flex between">
                    <p class="shoplist-li-money">
                      <span>¥</span>{{ item.shop_price }}
                    </p>
                    <img
                      src="@/assets/img/car.png"
                      class="shoplist-li__carimg"
                      @click="handleJg(item.goods_id)"
                    />
                    
                  </div>
                </div>
              </div>
              <template #finished>{{ finishtxt }}</template>
            </van-list>
          </div>
        </div>
        <div class="score-list-con">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="score-list-info"
              v-for="item in commentList"
              :key="item.id"
            >
              <div class="flex between center">
                <div class="flex center">
                  <img
                    :src="item.head_pic"
                    :onerror="Imgerror"
                    class="score-list-info__img"
                  />
                  <p class="score-list-info__name">{{ item.nickname }}</p>
                </div>
                <p class="score-list-info__time">{{ item.add_time }}</p>
              </div>
              <p class="score-list-info__desc size14"><span style="color:#f3956e">{{ item.score }}&nbsp;</span>{{ item.content }}</p>
              <div class="score-list-info-descimg flex">
                <img
                  :src="img"
                  :onerror="Imgerror"
                  v-for="(img, index) in item.images"
                  :key="index"
                />
              </div>
              <div class="reply" v-if="item.reply_content != ''">
                  <p class="size14">卖家回复：{{ item.reply_content }}</p>
                  <p class="size12">{{ item.reply_time }}</p>
                </div>
              <div class="flex score-action">
                <div class="flex">
                  <router-link
                    :to="{
                      path: '/shop/comment/detail',
                      query: { id: item.id, typeid: $route.query.typeid },
                    }"
                    class="flex"
                  >
                    <img src="@/assets/img/shop7.png" />
                    <p class="size14">({{ item.evaluate_count }}+)</p>
                  </router-link>
                </div>
                <div class="flex" @click="handleLike(item)">
                  <img
                    :src="
                      item.is_like === 0
                        ? require('@/assets/img/shop5.png')
                        : require('@/assets/img/shop5.png')
                    "
                  />
                  <p class="size14">({{ item.like_count }}+)</p>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ajax from "@/utils/request.js";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      commentList: [],
      condition: 0,
      sort: 0,
      goosList: null,
    };
  },
  methods: {
    handleSel(val) {
      this.page = 1;
      this.condition = val;
      this.sort = this.sort == 0 ? 1 : this.sort == 1 ? 2 : 0;
      this.goosList = [];
      this.getCommentList();
    },
    getCommentList() {
      this.loading = true;
      const data = {
        page: this.page,
        typeid: this.$route.query.typeid,
        goods_id: this.$route.query.goods_id,
        field: 1,
        sort: this.sort,
      };
      return ajax
        .post("products/getevaluatelist", data)
        .then((res) => {
          const list = res.data
          list.forEach((item,index) => {
            if(item.content == '' || item.content === null) {
              list.splice(index,1)
            }
          })
          if (res.data.length < 10) {

            this.commentList = list;
            this.finished = true;
          } else {
            this.commentList = this.commentList.concat(list);
            this.page++;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
    handleLike(item) {
      const data = {
        id: item.id,
        typeid: item.is_like === 0 ? 1 : 2,
      };
      ajax.post("products/like", data).then((res) => {
        if (res.errcode === 1) {
          if (item.is_like === 0) {
            item.is_like = 1;
            item.like_count = item.like_count + 1;
          } else {
            item.is_like = 0;
            item.like_count = item.like_count === 0 ? 0 : item.like_count - 1;
          }
          this.showToast(res.message)
          // item.is_like = item.is_like === 0?1:0
          // item.like_count = item.is_like === 0? item.like_count+1:item.like_count-1
        }
      });
    },
    next() {
      history.forward()
    },
    onLoad() {
      this.getCommentList().finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
    // this.getCommentList().finally(() => {
    //   this.loading = false;
    // });
  },
};
</script>
<style lang="scss" scoped>
.shopindex {
  display: flex;
  justify-content: flex-end;
  position: sticky;

  top: 44px;
  // margin-top: 30px;
  padding:20px 20px 0 20px;
  // height: 60px;
  // line-height: 60px;
  // background: #eee;
  // border-radius: 10px;
  // padding: 6px 6px;
}
.score-container {
  padding: 5.3333vw 4vw 60px;
  padding-top: 0;
}
.score-list {
  .score-list-tle {
    margin-top: 5.3333vw;
  }
  .score-list-con {
    padding: 2px 3.2vw;
    background: #f6f6f6;
    margin-top: 2.6667vw;
    border-radius: 2.1333vw;
    .score-list-info {
      padding: 2.6667vw 0;
      .score-list-info__img {
        width: 6.4vw;
        height: 6.4vw;
        border-radius: 50%;
        margin-right: 1.0667vw;
        background-color: skyblue;
      }
      .score-list-info__name {
        font-size: 14px;
        color: #333333;
      }
      .score-list-info__time {
        font-size: 12px;
        color: #999999;
      }
    }
    .score-list-info__desc {
      color: #666666;
      margin-top: 3.2vw;
    }
    .score-list-info-descimg {
      margin-top: 2.6667vw;
      img {
        object-fit: cover;
        width: 21.3333vw;
        height: 21.3333vw;
        margin-right: 2.6667vw;
        &:nth-child(4) {
          margin-right: 0;
        }
      }
    }
  }
  .score-action {
    justify-content: flex-end;
    margin-top: 2.6667vw;
    img {
      width: 5.3333vw;
      height: 5.3333vw;
      margin-left: 4.8vw;
      margin-right: 2px;
    }
  }
}
.reply {
  border-radius: 5px;
  background-color: #ddd;
  padding: 5px;
  p {
    word-break: break-all;
    &:first-child {
      margin-bottom: 5px;
    }
    &:last-child {
      color: #999;
    }
  }
}
</style>